import { Typography, Box } from "@mui/material";
import { useMemo } from "react";

const DashboardHeader = ({ ongoingWeeks }) => {
    const today = new Date();
    const formattedDate = today.toLocaleDateString("en-GB");
    const completedUntilWeek = useMemo(() => {
        if (!ongoingWeeks || ongoingWeeks.length === 0) return "--";

        const validWeeks = ongoingWeeks
            .map(w => Number(w))
            .filter(w => !isNaN(w) && w > 0);

        if (validWeeks.length === 0) return "--";

        const minWeek = Math.min(...validWeeks);

        return minWeek - 1;
    }, [ongoingWeeks]);

    return (
        <Box
            className="w-full rounded-xl px-4 py-3 md:p-12 grid grid-cols-1 md:grid-cols-[auto_1fr_auto] items-center gap-4"
            sx={{ bgcolor: "background.paper" }}
        >

            <Typography
                sx={{
                    color: "text.primary",
                    fontSize: 18,
                    fontWeight: 600,
                    whiteSpace: "nowrap",
                }}
            >
                Dashboard
            </Typography>

            <div className="flex justify-center items-center gap-14 flex-wrap">
                <div>
                    <Typography sx={{ color: "text.secondary", fontSize: 14 }}>
                        Booking Completed until Week:&nbsp;
                        <Box component="span" className="font-semibold" sx={{ color: "secondary.main" }}>
                            {completedUntilWeek}
                        </Box>
                    </Typography>
                </div>

                <div>
                    <Typography sx={{ color: "text.secondary", fontSize: 14 }}>
                        Booking Ongoing Weeks:&nbsp;
                        <Box component="span" className="font-semibold" sx={{ color: "secondary.main" }}>
                            {ongoingWeeks?.length ? ongoingWeeks.join(" & ") : "--"}
                        </Box>
                    </Typography>
                </div>
            </div>


            <Typography
                sx={{
                    color: "text.secondary",
                    fontSize: 13,
                    fontStyle: "italic",
                    whiteSpace: "nowrap",
                    textAlign: "right",
                }}
            >
                {formattedDate}
            </Typography>
        </Box>
    );
};

export default DashboardHeader;